module.exports = __webpack_public_path__ + "static/media/jogja.c2e5fc2f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sound/jogja.mp3
// module id = 143
// module chunks = 0